import { debug } from '../utils';

/**
 * Gpay /getIdentity API call to get user's identity details from GPAY app
 * @returns {object} identityAPIResponse - Response from GPAY /getIdentity API
 */
export const invokeGpayIdentitySpotAPI = async () => {
  debug('INFO', 'Initiating invokeGpayIdentityAPI ...');
  const identityAPIRequest = {
    nonce: 'nonce typically generated server-side',
    testVersion: 'v2',
  };

  let responseToReturn = {};
  const identityAPIResponse = await microapps
    .getIdentity(identityAPIRequest)
    .then((response) => {
      const decodedIdentityObj = JSON.parse(atob(response.split('.')[1]));
      debug('RESPONSE', `GPAY /getIdentity`, decodedIdentityObj);
      responseToReturn = {};
      responseToReturn.statusCode = 200;
      responseToReturn.body = decodedIdentityObj;
      return responseToReturn;
    })
    .catch((error) => {
      console.error('An error occurred: ', error);
      responseToReturn = {};
      responseToReturn.statusCode = 500;
      responseToReturn.body = {};
      return responseToReturn;
    });

  debug('FINAL RETURN', `GPAY /getIdentity`, identityAPIResponse);
  return identityAPIResponse;
};
